import React, { useEffect } from "react";

const sections = [
  "1. How We Collect & Use Your Personal Data",
  "2. How We Store Your Personal Data",
  "3. How We Share Your Personal Data",
  "4. How We Use Cookies",
  "5. Links to Third-Party Websites, Products, and Services",
  "6. How We Protect Your Personal Data",
  "7. How to Access & Control Your Personal Data",
  "8. How We Process Minors' Personal Data",
  "9. International Transfers of Your Personal Data",
  "10. Updates to This Policy",
  "11. How to Contact Us",
];

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={{ margin: 0 }}>Privacy Policy</h1>
        <p style={{ margin: "5px 0 0 0", opacity: 0.9 }}>
          Effective Date: March eight, 2026
        </p>
      </div>

      <div style={styles.container}>
        {/* Table of Contents */}
        <div style={styles.toc}>
          <h3>Contents</h3>
          {sections.map((sec, index) => (
            <a
              key={index}
              href={`#section-${index}`}
              style={styles.tocItem}
            >
              {sec}
            </a>
          ))}
        </div>

        {/* Content */}
        <div style={styles.content}>
          <p>
            Snapdeveloper's Cam Scanner is provided by Savariya IT Solutions. We attach great
            importance to protecting your personal data and privacy.
            By using our service, you agree to this Privacy Policy.
          </p>

          {sections.map((title, index) => (
            <div key={index} id={`section-${index}`} style={styles.sectionCard}>
              <h2>{title}</h2>
              <p>
                This section describes details regarding {title.toLowerCase()}.
                Please refer to the official policy text for complete
                legal wording and obligations.
              </p>
            </div>
          ))}

          <div style={styles.contactCard}>
            <h2>Contact Us</h2>
            <p>
              Email our Data Protection Officer:
              <strong> allnotesunderoneroof@gmail.com</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        style={styles.topButton}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        ↑
      </button>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: "Segoe UI, sans-serif",
    background: "linear-gradient(135deg, #f5f7fa, #e4ecf7)",
    minHeight: "100vh",
  },
  header: {
    position: "sticky",
    top: 0,
    background: "linear-gradient(90deg, #1a73e8, #4f9cff)",
    color: "white",
    padding: "20px",
    textAlign: "center",
    zIndex: 1000,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  container: {
    display: "flex",
    maxWidth: "1200px",
    margin: "40px auto",
    gap: "30px",
    padding: "0 20px",
  },
  toc: {
    flex: "0 0 280px",
    background: "white",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
    height: "fit-content",
    position: "sticky",
    top: "100px",
  },
  tocItem: {
    display: "block",
    margin: "8px 0",
    textDecoration: "none",
    color: "#1a73e8",
    fontSize: "14px",
  },
  content: {
    flex: 1,
  },
  sectionCard: {
    background: "white",
    padding: "25px",
    borderRadius: "12px",
    marginBottom: "25px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
    transition: "transform 0.2s ease",
  },
  contactCard: {
    background: "#1a73e8",
    color: "white",
    padding: "25px",
    borderRadius: "12px",
    marginTop: "40px",
  },
  topButton: {
    position: "fixed",
    bottom: "30px",
    right: "30px",
    background: "#1a73e8",
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    fontSize: "20px",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },
};

export default PrivacyPolicy;